<template>
  <v-layout>
    <v-flex>
      <v-data-table
        :headers="headers"
        :items="proveedoresApp"
        :search="search"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Proveedores App</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  outlined
                  icon
                  color="green"
                  v-bind="attrs"
                  v-on="on"
                  @click="listar()"
                  ><v-icon class="fa fa-sync-alt"></v-icon
                ></v-btn>
              </template>
              <span>Recargar</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-text-field
              class="text-xs-center"
              v-model="search"
              append-icon="search"
              label="Busqueda"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn color="green" dark @click="descargarExcel()"
              >Descargar</v-btn
            >

            <v-dialog v-model="dialogActivarDesactivar" max-width="400px">
              <v-card>
                <v-card-title class="headline" v-if="cardTitleActivar == 1"
                  >¿Activar cuenta de proveedor?</v-card-title
                >
                <v-card-title class="headline" v-if="cardTitleActivar == 2"
                  >Desactivar cuenta de proveedor?</v-card-title
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="cancel"
                    @click="cerrarDialogActivarDesactivar()"
                  >
                    Cancelar
                  </v-btn>
                  <v-btn
                    v-if="cardTitleActivar == 1"
                    color="success"
                    @click="updateStatus()"
                  >
                    Activar
                  </v-btn>
                  <v-btn
                    v-if="cardTitleActivar == 2"
                    color="warning"
                    @click="deleteStatus()"
                  >
                    Desactivar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <template v-if="item.status">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  @click="activarProveedor(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  block
                </v-icon>
              </template>
              <span>Desactivar cuenta</span>
            </v-tooltip>
          </template>
          <template v-else>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  @click="desactivarProveedor(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  check
                </v-icon>
              </template>
              <span>Activar cuenta</span>
            </v-tooltip>
          </template>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <v-chip :color="verificarStatus(item.status)" dark>
            <div v-if="item.status"><span>Activo</span></div>
            <div v-else><span>Inactivo</span></div>
          </v-chip>
        </template>
      </v-data-table>

      <v-overlay v-model="overlay" z-index="0">
        <lottie-player
          autoplay
          loop
          mode="normal"
          src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
          style="width: 320px"
        >
        </lottie-player>
      </v-overlay>
    </v-flex>
  </v-layout>
</template>
<script>
import { dbRefProveedor } from "../main";
import XLSX from "xlsx";
export default {
  data() {
    return {
      proveedoresApp: [],
      headers: [
        { text: "Opciones", align: "center", value: "action", sortable: false },
        {
          text: "Nombre",
          value: "name",
          align: "left",
        },
        {
          text: "Teléfono",
          value: "phone",
          align: "left",
        },
        {
          text: "Vehículo",
          value: "vehicleBrand",
          align: "left",
        },
        {
          text: "Placa",
          value: "vehiclePlate",
          align: "left",
        },
        {
          text: "Tipo de asistencia",
          value: "typeAssistance",
          align: "left",
        },
        {
          text: "Correo",
          value: "email",
          align: "left",
        },
        { text: "Estado", value: "status", align: "left" },
      ],
      search: "",
      id: "",
      dialogActivarDesactivar: false,
      cardTitleActivar: 1,
      overlay: false,
    };
  },
  created() {
    this.listar();
  },
  methods: {
    listar() {
      let me = this;
      me.overlay = true;
      me.proveedoresApp = [];
      dbRefProveedor.once("value", function (dataSnapshot) {
        if (dataSnapshot.val()) {
          dataSnapshot.forEach(function (childSnapshot) {
            me.proveedoresApp.push({
              id: childSnapshot.key,
              name: childSnapshot.val().name,
              phone: childSnapshot.val().phone,
              vehicleBrand: childSnapshot.val().vehicleBrand,
              vehiclePlate: childSnapshot.val().vehiclePlate,
              typeAssistance: childSnapshot.val().typeAssistance,
              email: childSnapshot.val().email,
              status: childSnapshot.val().status,
            });
          });
        }
        me.overlay = false;
      });
    },
    verificarStatus(status) {
      if (status) {
        return "green";
      } else {
        return "red";
      }
    },
    descargarExcel() {
      let me = this;
      me.overlay = true;
      let headerExcel = [];
      me.proveedoresApp.forEach(function (data) {
        headerExcel.push({
          NOMBRE: data.name,
          TELEFONO: data.phone,
          VEHICULO: data.vehicleBrand,
          PLACA: data.vehiclePlate,
          "TIPO DE ASISTENCIA": data.typeAssistance,
          CORREO: data.email,
        });
      });
      me.overlay = false;

      let data = XLSX.utils.json_to_sheet(headerExcel);
      const workbook = XLSX.utils.book_new();
      const filename = "Proveedores App";
      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
    activarProveedor(item) {
      let me = this;
      me.cardTitleActivar = 2;
      me.dialogActivarDesactivar = true;
      me.id = item.id;
    },
    desactivarProveedor(item) {
      let me = this;
      me.cardTitleActivar = 1;
      me.dialogActivarDesactivar = true;
      me.id = item.id;
    },
    updateStatus() {
      let me = this;
      me.overlay = true;
      dbRefProveedor
        .child(this.id)
        .update({ status: "active_driver" })
        .then(function () {
          me.dialogActivarDesactivar = false;
          me.listar();
          me.overlay = false;
        })
        .catch(function (error) {
          console.log("Remove failed: " + error.message);
          me.overlay = false;
        });
    },
    deleteStatus() {
      let me = this;
      me.overlay = true;
      dbRefProveedor
        .child(this.id + "/" + "status")
        .remove()
        .then(function () {
          me.dialogActivarDesactivar = false;
          me.listar();
          me.overlay = false;
        })
        .catch(function (error) {
          console.log("Remove failed: " + error.message);
          me.overlay = false;
        });
    },
    cerrarDialogActivarDesactivar() {
      this.dialogActivarDesactivar = false;
    },
  },
};
</script>